

import React                      from 'react'
import { Select }                 from 'antd'
import { SelectProps }            from 'antd/lib/select'
import { Observer }               from 'mobx-react'

import { AVAIL_LANGS
       , current_lang
       , set_lang }               from '../00_assets'


export const SelectLang: React.FC< SelectProps > = ( props ) =>
<Observer render={ ( ) => 
{
  const on_change = ( new_lang: any ) => set_lang( new_lang )
      
  return <Select value={ current_lang( ) } onChange={ on_change } {...props}>
           { AVAIL_LANGS.map( lang =>
              <Select.Option value={ lang } key={ lang }>{ lang }</Select.Option>
           ) }
          </Select> ;
}} />
